export enum RegistrationMedium {
  ONBOARDING,
  CONFIGURATION
}
